import createDataContext from "./createDataContext";
import dataApi from "../api/data";

const gamesReducer = (state, action) => {
  switch (action.type) {
    case "toggle_modal":
      if (action.payload === false) {
        return {
          ...state,
          gameModal: action.payload,
          formStep: 1,
          game_group_name: "",
          game_group_players: 0,
          game_group_nameValidationMessage: "",
          game_group_nameValidated: null,
          game_group_playersValidationMessage: "",
          game_group_playersValidated: null,
          world_count: 0,
          selected_product: null,
          tags_string: "",
        };
      } else {
        return { ...state, gameModal: action.payload };
      }
    case "set_product_data":
      return { ...state, products: action.payload, errorMessage: "" };
    case "set_game_data":
      return { ...state, game_card_list: action.payload, errorMessage: "" };
    case "set_selected_product":
      return { ...state, selected_product: action.payload };
    case "change_form_step":
      if (action.payload === 1 && state.formStep !== state.maxFormStep) {
        return { ...state, formStep: state.formStep + action.payload };
      } else if (action.payload === -1 && state.formStep > 0) {
        return { ...state, formStep: state.formStep + action.payload };
      }
      break;
    case "update_game_group_name_input":
      const {
        game_group_name,
        game_group_nameValidated,
        game_group_nameValidationMessage,
      } = action.payload;
      return {
        ...state,
        game_group_name,
        game_group_nameValidationMessage,
        game_group_nameValidated,
      };
    case "update_game_group_players_input":
      const {
        game_group_players,
        game_group_playersValidated,
        game_group_playersValidationMessage,
        world_count,
      } = action.payload;
      return {
        ...state,
        game_group_players,
        game_group_playersValidationMessage,
        game_group_playersValidated,
        world_count,
      };
    case "update_game_group_tags":
      return {
        ...state,
        tags_string: action.payload.tags_string,
        tag_list: action.payload.tag_list,
      };
    case "update_game_group_invites":
      return {
        ...state,
        game_group_invite_string: action.payload.game_group_invite_string,
        game_group_invite_list: action.payload.game_group_invite_list,
      };
    default:
      return state;
  }
};

const getProductLibrary = (dispatch) => async () => {
  try {
    const response = await dataApi.get("/product_list/");
    dispatch({ type: "set_product_data", payload: response.data });
  } catch (err) {
    console.log(err);
  }
};

const getGameGroupList =
  (dispatch) =>
  async ({ user_id }) => {
    const response = await dataApi.get("/games", {
      params: {
        user_id,
      },
    });
    const { data } = response;
    const { success, game_groups_data } = data;
    if (success === true) {
      dispatch({ type: "set_game_data", payload: game_groups_data });
    }
  };

const toggleGameModal = (dispatch) => (modalState) => {
  dispatch({ type: "toggle_modal", payload: !modalState });
};

const formNavigate =
  (dispatch) =>
  ({ diff }) => {
    dispatch({ type: "change_form_step", payload: diff });
  };

const handleInputChange =
  (dispatch) =>
  ({ name, value, selected_product }) => {
    const { players_per_world } = selected_product;
    const validateInput = (name, value) => {
      if (name === "game_group_name") {
        if (value === "") {
          dispatch({
            type: "update_game_group_name_input",
            payload: {
              game_group_name: value,
              game_group_nameValidationMessage:
                "Please enter a name for your game.",
              game_group_nameValidated: false,
            },
          });
        } else {
          dispatch({
            type: "update_game_group_name_input",
            payload: {
              game_group_name: value,
              game_group_nameValidationMessage: "",
              game_group_nameValidated: true,
            },
          });
        }
      } else if (name === "game_group_players") {
        let world_count = Math.ceil(
          parseInt(value) / parseInt(players_per_world)
        );
        if (parseInt(value) === 0) {
          dispatch({
            type: "update_game_group_players_input",
            payload: {
              game_group_players: value,
              game_group_playersValidationMessage: "Please enter a value",
              game_group_playersValidated: false,
              world_count,
            },
          });
        } else {
          dispatch({
            type: "update_game_group_players_input",
            payload: {
              game_group_players: value,
              game_group_playersValidationMessage: "",
              game_group_playersValidated: true,
              world_count,
            },
          });
        }
      } else if (name === "tags_string") {
        dispatch({
          type: "update_game_group_tags",
          payload: {
            tags_string: value,
            tag_list: value.replace(/\s+/g, "").split(","),
          },
        });
      } else if (name === "game_group_invite_string") {
        dispatch({
          type: "update_game_group_invites",
          payload: {
            game_group_invite_string: value,
            game_group_invite_list: value.replace(/\s+/g, "").split(","),
          },
        });
      }
    };
    validateInput(name, value);
  };

const setProduct =
  (dispatch) =>
  ({ product }) => {
    dispatch({ type: "set_selected_product", payload: product });
  };

//
const createGame =
  (dispatch) =>
  async ({
    game_group_name,
    tag_list,
    product_id,
    user_id,
    world_count,
    game_group_invite_list,
  }) => {
    try {
      const response = await dataApi.post("/games", {
        data: {
          game_group_name,
          tag_list,
          product_id,
          user_id,
          world_count,
          game_group_invite_list,
        },
      });
      const { data } = response;
      const { success, game_groups_data } = data;
      if (success === true) {
        dispatch({ type: "set_game_data", payload: game_groups_data });
        dispatch({ type: "toggle_modal", payload: false });
      }
    } catch (err) {
      console.log("Error from creating game: ", err);
    }
  };

export const { Provider, Context } = createDataContext(
  gamesReducer,
  {
    getGameGroupList,
    getProductLibrary,
    formNavigate,
    createGame,
    toggleGameModal,
    handleInputChange,
    setProduct,
  },
  {
    products: null,
    selected_product: null,
    selected_product_type: "competition sim",
    formStep: 1,
    maxFormStep: 3,
    gameModal: false,
    game_card_list: [],
    game_group_name: "",
    game_group_nameValidationMessage: "",
    game_group_nameValidated: null,
    game_group_players: "",
    game_group_playersValidated: null,
    game_group_playersValidationMessage: "",
    world_count: 0,
    tags_string: "",
    tag_list: [],
    game_group_invite_string: "",
    game_group_invite_list: [],
    success_message: "",
  }
);
